module.exports = __webpack_public_path__ + "img/053.b9c17b2a.jpeg";